module.exports = __webpack_public_path__ + "static/media/logo.c7e2da64.png";